export default "__VITE_ASSET__BN2Php$6__"